import React, { useState, useEffect } from 'react';
import SEO from "../components/SEO";
import BackButton from '../components/BackButton';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import bgImg from '../assets/bg-imag.png';

export default function Question() {
  const { slug, q } = useParams();
  const navigate = useNavigate();

  const [question, setQuestion] = useState(null);
  const [title, setTitle] = useState('');
  const [duration, setDuration] = useState('');
  const [answers, setAnswers] = useState({});
  const [totalQuestions, setTotalQuestions] = useState(0);
  const [progress, setProgress] = useState(0);
  const [questionNumbers, setQuestionNumbers] = useState([]);
  const [showSidebar, setShowSidebar] = useState(false);
  const [userAssessmentId, setUserAssessmentId] = useState(null);
  const [sidebarTab, setSidebarTab] = useState('all');
  const [questionAnswersByNumber, setQuestionAnswersByNumber] = useState({});


  const [timeLeft, setTimeLeft] = useState(null);
  const [warningShown5, setWarningShown5] = useState(false);
  const [warningShown1, setWarningShown1] = useState(false);
  const [timerInitialized, setTimerInitialized] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);


  const currentIndex = parseInt(q) || 1;

  useEffect(() => {
    const guestUserId = localStorage.getItem('guest_user_id');
    const userAssessmentId = localStorage.getItem('user_assessment_id');
    // console.log(userAssessmentId);
    const storedSlug = localStorage.getItem('assessment_id');

    const isSessionValid = guestUserId && userAssessmentId && storedSlug === slug;

    if (!isSessionValid) {
      navigate(`/assessment/${slug}/form`);
      return;
    }

    setUserAssessmentId(userAssessmentId);

    axios.get(`/${slug}/questions/${currentIndex}`)
      .then(res => {
        const data = res.data;
        const qData = data.screen.question;
        setQuestion(qData);
        setTitle(data.assessment_title);
        setDuration(data.duration_minutes);
        // Set time only once
        if (!timerInitialized) {
          setTimeLeft(data.duration_minutes * 60);
          setTimerInitialized(true);
        }
        setTotalQuestions(data.total_screens);
        setProgress((currentIndex / data.total_screens) * 100);
        setQuestionNumbers(Array.from({ length: data.total_screens }, (_, i) => i + 1));
      })
      .catch(() => {
        setQuestion(null);
        alert('Failed to load question');
      });
  }, [slug, currentIndex]);

  /**
  * Separate useEffect ONLY for logging `question` changes.
  * This avoids multiple [object Object] spam when fetching questions.
  */
  useEffect(() => {
    // if (question) {
    //   console.log("Question object:", question);
    // }
  }, [question]);// Will run only when question state changes

  /////////
  useEffect(() => {
    if (timeLeft === null) return;

    if (timeLeft <= 0) {
      alert("Time's up! Auto-submitting your test...");
      submitAnswers();
      return;
    }

    if (timeLeft === 300 && !warningShown5) {
      alert("⚠️ 5 minutes remaining!");
      setWarningShown5(true);
    }

    if (timeLeft === 60 && !warningShown1) {
      alert("⚠️ 1 minute remaining!");
      setWarningShown1(true);
    }

    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeLeft]);
  ///////////



  const handleAnswer = (value) => {
    if (!question) return;
    // setAnswers({ ...answers, [question.id]: value });
    setAnswers(prev => ({ ...prev, [question.id]: value }));
    setQuestionAnswersByNumber(prev => ({ ...prev, [currentIndex]: value }));
  };

  const handleNext = () => {
    if (currentIndex < totalQuestions) {
      navigate(`/${slug}/questions/${currentIndex + 1}`);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 1) {
      navigate(`/${slug}/questions/${currentIndex - 1}`);
    }
  };

  const submitAnswers = async () => {
    const user_assessment_id = localStorage.getItem('user_assessment_id');
    if (!user_assessment_id) {
      alert('Assessment not started properly');
      return;
    }

    try {
      setIsSubmitting(true);

      const payloads = Object.entries(answers).map(([question_id, value]) =>
        axios.post('/answers', {
          user_assessment_id,
          question_id,
          selected_option_ids: Array.isArray(value) ? value : [value],
          submitted_at: new Date().toISOString()
        })
      );

      await Promise.all(payloads);

      const res = await axios.patch(`/guest-test/submit/${user_assessment_id}`);

      if (res.data?.status === 'completed') {
        localStorage.removeItem('guest_user_id');
        localStorage.removeItem('user_assessment_id');
        localStorage.removeItem('assessment_id');

        setShowSubmitPopup(true);
        setTimeout(() => {
          navigate(`/assessment/${user_assessment_id}/result`);
        }, 2000);
      } else {
        alert('Submission failed!');
      }
    } catch (err) {
      console.error(err);
      alert('Failed to submit answers');
    } finally {
      setIsSubmitting(false);
    }
  };

  const renderOptions = () => {
    if (!question) return null;

    const baseOptionStyle = "block p-3 mb-3 border rounded-lg cursor-pointer transition-all duration-300";
    const selectedStyle = "bg-green-lightGreen border-green-green font-semibold";
    const unselectedStyle = "bg-white border-gray-300 hover:bg-gray-50";

    switch (question.type) {
      case 'mcq':
        return question.options.map(opt => {
          const isSelected = answers[question.id] === opt.id;
          return (
            <label
              key={opt.id}
              className={`${baseOptionStyle} ${isSelected ? selectedStyle : unselectedStyle}`}
            >
              <input
                type="radio"
                name={`q-${question.id}`}
                value={opt.id}
                checked={isSelected}
                onChange={() => handleAnswer(opt.id)}
                className="hidden"
              />
              {opt.text}
            </label>
          );
        });

      case 'checkbox':
        return question.options.map(opt => {
          const selected = answers[question.id]?.includes(opt.id);
          return (
            <label
              key={opt.id}
              className={`${baseOptionStyle} ${selected ? selectedStyle : unselectedStyle}`}
            >
              <input
                type="checkbox"
                value={opt.id}
                checked={selected}
                onChange={(e) => {
                  const prev = answers[question.id] || [];
                  handleAnswer(
                    e.target.checked
                      ? [...prev, opt.id]
                      : prev.filter(v => v !== opt.id)
                  );
                }}
                className="hidden"
              />
              {opt.text}
            </label>
          );
        });

      case 'true_false':
        return ['True', 'False'].map(val => {
          const isSelected = answers[question.id] === val;
          return (
            <label
              key={val}
              className={`${baseOptionStyle} ${isSelected ? selectedStyle : unselectedStyle}`}
            >
              <input
                type="radio"
                name={`q-${question.id}`}
                value={val}
                checked={isSelected}
                onChange={() => handleAnswer(val)}
                className="hidden"
              />
              {val}
            </label>
          );
        });

      case 'blank':
      case 'essay':
        return (
          <textarea
            className="w-full border border-gray-300 p-3 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-400"
            placeholder="Write your answer..."
            value={answers[question.id] || ''}
            onChange={e => handleAnswer(e.target.value)}
          />
        );

      default:
        return <p className="text-red-600">Unsupported question type</p>;
    }
  };


  if (!question) return <p className="text-center p-4">Loading question...</p>;

  return (
<>
<SEO
        title={title || "Free Skill Assessment &amp; Practice Tests"}
        noindex
      />
    <div className="py-[36px] md:py-[72px] min-h-screen" style={{
      backgroundImage: `url(${bgImg})`, // Correct use of template literals to inject bgImg
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="mx-auto w-full max-w-full sm:max-w-[40rem] md:max-w-[48rem] lg:max-w-[62rem] xl:max-w-[62rem] bg-[#F6F6F6] p-9 rounded-xl border border-[#D9D9D9]">

        {/* Top row: question count + timer-badge */}
        <div className="mb-3 flex items-center justify-between">
          <div className="text-sm font-medium text-gray-700">Q{currentIndex}:/{totalQuestions} Questions </div>

          {/* Timer styled like a rounded button */}
          <div className="inline-flex items-center gap-4 rounded-full bg-green-lightGreen text-sm font-semibold text-gray-800 shadow-sm px-6 py-2">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <g clipPath="url(#clip0_16695_2382)">
                <path d="M9.00152 1.41V1C9.00152 0.734784 8.89616 0.48043 8.70862 0.292893C8.52109 0.105357 8.26673 0 8.00152 0C7.7363 0 7.48195 0.105357 7.29441 0.292893C7.10687 0.48043 7.00152 0.734784 7.00152 1V1.41C5.72975 1.58173 4.52559 2.08513 3.51 2.86964C2.49441 3.65415 1.70318 4.69213 1.21581 5.87928C0.728437 7.06644 0.562086 8.36095 0.733472 9.63276C0.904858 10.9046 1.40794 12.1089 2.19218 13.1247C1.91615 13.3515 1.69547 13.6384 1.54691 13.9633C1.39835 14.2883 1.32583 14.6428 1.33485 15C1.33485 15.2652 1.44021 15.5196 1.62774 15.7071C1.81528 15.8946 2.06963 16 2.33485 16C2.60007 16 2.85442 15.8946 3.04196 15.7071C3.22949 15.5196 3.33485 15.2652 3.33485 15C3.32466 14.9009 3.3494 14.8014 3.40478 14.7186C3.46016 14.6359 3.54272 14.575 3.63818 14.5467C4.89717 15.4894 6.42768 15.9989 8.00052 15.9989C9.57335 15.9989 11.1039 15.4894 12.3629 14.5467C12.4587 14.5747 12.5417 14.6353 12.5975 14.7181C12.6532 14.8009 12.6783 14.9007 12.6682 15C12.6682 15.2652 12.7735 15.5196 12.9611 15.7071C13.1486 15.8946 13.403 16 13.6682 16C13.9334 16 14.1878 15.8946 14.3753 15.7071C14.5628 15.5196 14.6682 15.2652 14.6682 15C14.6772 14.6428 14.6047 14.2883 14.4561 13.9633C14.3076 13.6384 14.0869 13.3515 13.8109 13.1247C14.5951 12.1089 15.0982 10.9046 15.2696 9.63276C15.4409 8.36095 15.2746 7.06644 14.7872 5.87928C14.2998 4.69213 13.5086 3.65415 12.493 2.86964C11.4774 2.08513 10.2733 1.58173 9.00152 1.41ZM2.66818 8.66667C2.66818 7.61183 2.98098 6.58069 3.56701 5.70363C4.15305 4.82656 4.986 4.14298 5.96054 3.73931C6.93508 3.33564 8.00743 3.23002 9.042 3.43581C10.0766 3.6416 11.0269 4.14955 11.7728 4.89543C12.5186 5.64131 13.0266 6.59162 13.2324 7.62619C13.4382 8.66075 13.3325 9.73311 12.9289 10.7076C12.5252 11.6822 11.8416 12.5151 10.9646 13.1012C10.0875 13.6872 9.05635 14 8.00152 14C6.58752 13.9984 5.23188 13.436 4.23203 12.4361C3.23218 11.4363 2.66977 10.0807 2.66818 8.66667Z" fill="#00A538" />
                <path d="M13 0.0012864C12.7348 0.0012864 12.4804 0.106643 12.2929 0.29418C12.1054 0.481716 12 0.73607 12 1.00129C12 1.2665 12.1054 1.52086 12.2929 1.70839C12.4804 1.89593 12.7348 2.00129 13 2.00129C13.1327 1.99096 13.2661 2.00997 13.3907 2.05698C13.5152 2.10398 13.6279 2.17782 13.7208 2.27326C13.8136 2.36869 13.8843 2.48339 13.9278 2.60921C13.9714 2.73503 13.9867 2.86889 13.9727 3.00129C13.9727 3.2665 14.078 3.52086 14.2656 3.70839C14.4531 3.89593 14.7074 4.00129 14.9727 4.00129C15.2379 4.00129 15.4922 3.89593 15.6798 3.70839C15.8673 3.52086 15.9727 3.2665 15.9727 3.00129C15.9881 2.6055 15.922 2.21077 15.7784 1.84162C15.6349 1.47247 15.4169 1.13679 15.1381 0.85544C14.8593 0.574087 14.5257 0.353074 14.1578 0.206134C13.79 0.0591943 13.3959 -0.0105325 13 0.0012864Z" fill="#00A538" />
                <path d="M2.02563 3.00129C2.01164 2.86889 2.02695 2.73503 2.07048 2.60921C2.11401 2.48339 2.1847 2.36869 2.27753 2.27326C2.37036 2.17782 2.48305 2.10398 2.60762 2.05698C2.73218 2.00997 2.86556 1.99096 2.9983 2.00129C3.26352 2.00129 3.51787 1.89593 3.70541 1.70839C3.89294 1.52086 3.9983 1.2665 3.9983 1.00129C3.9983 0.73607 3.89294 0.481716 3.70541 0.29418C3.51787 0.106643 3.26352 0.0012864 2.9983 0.0012864C2.60239 -0.0105325 2.20828 0.0591943 1.84046 0.206134C1.47264 0.353074 1.13897 0.574087 0.860182 0.85544C0.581393 1.13679 0.363443 1.47247 0.219876 1.84162C0.0763086 2.21077 0.0101918 2.6055 0.0256338 3.00129C0.0256338 3.2665 0.130991 3.52086 0.318527 3.70839C0.506063 3.89593 0.760417 4.00129 1.02563 4.00129C1.29085 4.00129 1.5452 3.89593 1.73274 3.70839C1.92028 3.52086 2.02563 3.2665 2.02563 3.00129Z" fill="#00A538" />
                <path d="M9.01953 8.25397V5.66797C9.01953 5.40275 8.91417 5.1484 8.72664 4.96086C8.5391 4.77333 8.28475 4.66797 8.01953 4.66797C7.75431 4.66797 7.49996 4.77333 7.31242 4.96086C7.12489 5.1484 7.01953 5.40275 7.01953 5.66797V8.52997C7.01961 8.88356 7.16013 9.22265 7.4102 9.47264L8.60553 10.668C8.79413 10.8501 9.04674 10.9509 9.30893 10.9486C9.57113 10.9464 9.82194 10.8412 10.0074 10.6558C10.1928 10.4704 10.2979 10.2196 10.3002 9.95737C10.3025 9.69517 10.2017 9.44257 10.0195 9.25397L9.01953 8.25397Z" fill="#00A538" />
              </g>
              <defs>
                <clipPath id="clip0_16695_2382">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>

            <span className='text-green-green font-bold'>
              {Math.floor(timeLeft / 60)}:{String(timeLeft % 60).padStart(2, '0')}
            </span>

          </div>
        </div>

        <div className="mb-4 h-2 w-full bg-gray-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-red-600 rounded-full transition-all duration-300"
            style={{ width: `${progress}%` }}
          />
        </div>

        <h1 className="text-lg font-semibold mb-2 text-grey-disable">{title}</h1>


        {question.scenario_description && (
          <div className="mb-4 p-3 bg-yellow-50 border-l-4 border-yellow-400">
            <p className="text-sm text-gray-700">{question.scenario_description}</p>
          </div>
        )}

        <h2 className="text-base font-semibold mb-4 text-gray-800">
          Q{currentIndex}: {question.title}
        </h2>

        <div className="mb-6">{renderOptions()}</div>

        <div className="flex justify-between gap-4">
          <div>
            {parseInt(q) > 1 && (
              <button
                onClick={handlePrev}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 rounded"
                disabled={currentIndex === 1}
              >
                Previous
              </button>
            )}
          </div>
          <div className=''>
            {currentIndex < totalQuestions && (
              <button
                onClick={handleNext}
                className="px-4 py-2 bg-green-green hover:bg-green-dark text-white rounded"
              >
                Next
              </button>
            )}
          </div>

          {currentIndex === totalQuestions && (
            <div className="mt-6 space-y-4">
              <button
                onClick={submitAnswers}
                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
              >
                {isSubmitting ? 'Submitting...' : 'Submit All Answers'}
              </button>
            </div>
          )}
        </div>

        <div className="mt-4 text-center">
          <button
            onClick={() => setShowSidebar(true)}
            className="text-[#080808] font-bold"
          >
            Jump to Any Question
          </button>
        </div>
      </div>

      {showSidebar && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-end z-50">
          <div className="w-100 bg-[#F6F6F6] p-4 h-full shadow-lg overflow-y-auto transform translate-x-full animate-slide-in-right"
            style={{ animation: 'slide-in 0.3s ease-out forwards' }}>

            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-bold text-[#080808]">Jump to Question</h3>
              <button
                onClick={() => setShowSidebar(false)}
                className="text-sm text-[#E50914] hover:underline"
              >
                Close
              </button>
            </div>

            {/* Filter Buttons */}
            <div className="flex justify-between mb-4 border-b gap-3 border-[#D9D9D9]">
              {['all', 'unanswered', 'answered'].map(tab => (
                <button
                  key={tab}
                  onClick={() => setSidebarTab(tab)}
                  className={`flex-1 py-2 text-sm font-semibold capitalize transition-colors ${sidebarTab === tab
                    ? 'text-[#E50914] border-b-2 border-[#E50914]'
                    : 'text-[#080808] hover:text-[#E50914]'
                    }`}
                >
                  {tab}
                </button>
              ))}
            </div>

            {/* Questions */}
            <div className="space-y-2">
              {questionNumbers
                .filter((num) => {
                  const ans = questionAnswersByNumber[num];

                  const isAnswered = ans !== undefined && (
                    (typeof ans === 'string' && ans.trim() !== '') ||
                    (Array.isArray(ans) && ans.length > 0) ||
                    (typeof ans === 'number')
                  );

                  if (sidebarTab === 'answered') return isAnswered;
                  if (sidebarTab === 'unanswered') return !isAnswered;
                  return true;
                })
                .map((num) => (
                  <button
                    key={num}
                    onClick={() => {
                      setShowSidebar(false);
                      navigate(`/${slug}/questions/${num}`);
                    }}
                    className="block w-full text-left px-4 py-2 bg-white hover:bg-[#D9D9D9] border border-[#D9D9D9] rounded text-sm text-[#080808]"
                  >
                    Q{num}
                  </button>
                ))}
            </div>
          </div>
        </div>
      )}

      {showSubmitPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg text-center max-w-sm">
            <h2 className="text-green-600 text-xl font-semibold mb-2">✅ Submitted!</h2>
            <p className="text-gray-700">Your test has been submitted successfully.</p>
          </div>
        </div>
      )}

    </div>
    </>
  );
}
